<script>
import base from './base.vue';
export default {
    extends:base,
    data(){
        return{
            title:'采购退货单',
            isPurchase:2,
            baseNum:'/material/order/generateReturnNum',
        }
    },
    created(){
        this.cols[1].hide = true;//退货单库存隐藏
    },
    methods:{
        checkend(obj){
            if(this.editMode==1){
                obj.id = this.orderid;
                this.$api.editReturn(obj).then(res=>{
                    if(res.data.code==1){
                        this.$notify({
                            title: "编辑采购退货单",
                            message: "编辑成功",
                            type: "success",
                            duration: 1000,
                        });
                        this.$router.push('/refund');
                    }else{
                        this.$common.error('编辑失败');
                        this.lock = false;
                    }
                })
            }else{
                this.$api.createReturn(obj).then(res=>{
                    if(res.data.code==1){
                        this.$notify({
                            title: "新增采购退货单",
                            message: "新增成功",
                            type: "success",
                            duration: 1000,
                        });
                        this.$router.push('/refund');
                    }else{
                        this.$common.error('新增失败');
                        this.lock = false;
                    }
                })
            }
            
        }
    }
}
</script>